import React from 'react';
import './MissionCard.css';

const MissionCard = ({ date, company, role, details, logo }) => {
  const showLogo = logo && logo !== 'no-image.jpg';
  const companyInitial = company.charAt(0).toUpperCase();

  return (
    <article className="mission-card group rounded-lg border border-[var(--border-color)] bg-[var(--bg-card)] p-5 shadow-sm transition hover:-translate-y-0.5 hover:border-[var(--accent-gold)] hover:shadow-lg md:p-6">
      <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0 text-left">
          <div className="mb-3 flex flex-wrap items-center gap-2">
            <span className="inline-flex rounded-full border border-[var(--border-color)] px-3 py-1 text-xs font-semibold text-[var(--text-secondary)] md:hidden">
              {date}
            </span>
          </div>
          <h2 className="text-xl font-bold leading-tight text-[var(--text-primary)]">
            {role}
          </h2>
          <p className="mt-1 text-base font-semibold text-[var(--accent-gold)]">
            {company}
          </p>
        </div>
        <div className="flex h-16 w-full shrink-0 items-center justify-start sm:w-36 sm:justify-center">
          {showLogo ? (
            <img
              src={`/logos/${logo}`}
              alt={`${company} logo`}
              className="max-h-10 max-w-[8rem] object-contain opacity-90 transition group-hover:opacity-100"
            />
          ) : (
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[var(--bg-tertiary)] text-lg font-bold text-[var(--accent-gold)]">
              {companyInitial}
            </span>
          )}
        </div>
      </div>

      <ul className="mt-5 space-y-2 text-left text-sm leading-relaxed text-[var(--text-secondary)] md:text-base">
        {details.map((detail, index) => (
          <li key={index} className="flex gap-3">
            <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[var(--accent-green)]" aria-hidden="true" />
            <span>{detail}</span>
          </li>
        ))}
      </ul>

    </article>
  );
};

export default MissionCard;
